export const AI_NAV_KEYS = {
  internalChatbot: "internal-chatbot",
};

export const AI_VIEWS = {
  INTERNAL_CHATBOT: {
    viewId: AI_NAV_KEYS.internalChatbot,
    path: `/${AI_NAV_KEYS.internalChatbot}`,
    title: "Internal chatbot",
  },
};

export const QUERY_STATUSES = {
  true: true,
  false: false,
  null: null,
};
